import AotModel from "../components/AotModel";
import CoupleModel from "../components/CoupleModel";
import envConfig from "../config.json";
const application_type = envConfig.application_type;
const COUPLE_TYPE = "couple";
/**
 * Component used to handle Model page
 */
const Model = () => {
  return (
    <>
      {application_type === COUPLE_TYPE ? (
        <CoupleModel></CoupleModel>
      ) : (
        <AotModel></AotModel>
      )}
    </>
  );
};

export default Model;
